<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row" v-if="customerId || $store.state.userData.isOrganization">
                <div class="col-12 mb-2" v-if="Object.keys(legalCustomerDetails).length">
                    <h5>اطلاعات سازمان</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover user-details-table">
                            <tbody>
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-4">
                            <label>انتخاب فایل درخواست</label>
                            <div class="input-group file-browser">
                                <input type="text" class="form-control border-left-0 browse-file" id="contract-file" placeholder="آپلود فایل" readonly="">
                                <label class="input-group-btn mb-0">
                                    <span class="btn btn-primary">
                                        انتخاب کنید <input type="file" style="display: none;" accept=".xlsx" @input="setFile">
                                    </span>
                                </label>
                            </div>
                            <p class="mt-3 mb-0">
                                <a href="#" @click="e => getExcelSample(e)">دریافت فایل نمونه</a>
                            </p>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>نوع درخواست</label>
                                <select class="form-control" v-model="type">
                                    <option value="4">مسدودی</option>
                                    <option value="5">رفع مسدودی</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-12 mt-4">
                            <button class="btn btn-success" v-if="file" @click="submit">ثبت درخواست</button>
                            <button class="btn btn-primary mr-2" v-if="resultFile" @click="getResultExcelFile">دریافت فایل نتیجه</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="domain">سازمان</label>
                        <Vselect @input="searchCustomer" v-model="nationalCode" :reduce="item => item.nationalId" label="title" :options="organizations">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <form v-on:submit.prevent="searchCustomer">
                        <label for="national-code">شناسه ملی</label>
                        <div class="input-group">
                            <input class="form-control text-left" maxlength="11" id="national-code" type="tel" v-model="nationalCode">
                            <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardPassword',
    data(){
        return {
            resultFile: '',
            showLoading: false,
            nationalCode: '',
            legalCustomerDetails: {},
            file: '',
            organizations: [],
            type: 4,
            customerId: 0
        }
    },
    methods: {
        getData(){
            this.$api.get('Cards/Deposits').then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    let deposits = data.result;
                    deposits.sort((a,b) => {
                        return a.depositValue - b.depositValue;
                    })
                    this.depositsList = deposits;
                }
            });
            const postedData = {
                page: 1,
                perPage: 500
            };
            this.$api.post('Management/organizations/List',postedData).then(({data}) => {
                let organizations = [];
                data.result.list.map(item => {
                    organizations.push({
                        title: item.domainMetaData.companyNameFa,
                        nationalId: item.domainMetaData.nationalId
                    });
                });
                this.organizations = organizations;
            });
        },
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status){
                    this.legalCustomerDetails = data.result;
                    this.customerId = data.result.customerId;
                }
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        getExcelSample(e){
            e.preventDefault();
            this.$api.get('Organizations/Bonus/Request/Sample').then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            this.resultFile = '';
            document.getElementById('contract-file').setAttribute('placeholder',file.name);
        },
        getResultExcelFile(){
            let a = window.document.createElement('a');
            a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + this.resultFile);
            let fileName = this.resultFile;
            a.setAttribute('download',fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        submit(){
            this.showLoading = true;
            let postedData = {
                fileString: this.file,
                type: parseInt(this.type)
            };
            if(this.customerId)
                postedData['organizationId'] = this.customerId;
            this.$api.post('Organizations/Bonus/Request',postedData).then(({data}) => {
                this.resultFile = data.result ? data.result.fileString : '';
                let message = 'ثبت درخواست ';
                if(this.type == 4) message += 'مسدودی کارت با موفقیت ثبت شد';
                else message += 'رفع مسدودی کارت با موفقیت ثبت شد';
                if(data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: message,
                    }).then(res => {
                        if(res.isConfirmed){
                            this.$router.push({name: 'bonusCards.requests'});
                        }
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>